module.exports = __webpack_public_path__ + "static/uber_395x510-9216f932e4df5fbf271b613832435267.webp";